/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable global-require */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Link,
  useNavigate,
  useLocation,
  ScrollRestoration,
  Outlet,
} from "react-router-dom";
import { ReactCompareSlider } from "react-compare-slider";
import Slider, { Settings } from "react-slick";
import { getDatabase, ref, onValue } from "firebase/database";
import Lottie from "lottie-web";
import useSWR from "swr";
import { ReactChannelIO } from "react-channel-plugin";
import ScrollContainer from "react-indiana-drag-scroll";
import rightArrow from "../assets/img/icons/icon_right arrow_center align_grey_16.svg";
import Navbar from "../components/Navbar";
import IcInstagram from "../assets/img/icons/icon_sns_insta_grey_32.svg";
import IcYoutube from "../assets/img/icons/icon_sns_youtube_grey_32.svg";
import api from "../store/api";
import LogoText from "../assets/img/logo_black.jpg";
import LogoTextWebp from "../assets/img/logo_black.webp";
import bell from "../assets/img/icons/icon_navigation_alarm_black_24.svg";
import TimelineBox from "../components/Timeline/TimelineBox";
import { firebaseInstance } from "../firebase";
import { actionsMyInfo } from "../store/myinfo/myinfoSlice";
import { thunkLogin } from "../store/login/loginAction";
import { stateLogin } from "../store/login/loginSlice";
import { reviewActions } from "../store/review/reviewSlice";
import PopupSlide from "../components/PopupSlide";
import comma from "../lib/client/comma";
import ChannelBot from "../components/ChannelBot";
import Splash2 from "../components/Splash2";
import getCookie from "../lib/client/getCookie";
import SubBannerSvg from "../assets/img/subBanner.svg";
import SubBannerWebp from "../assets/img/subBanner.webp";
import CatBag from "../assets/img/cat_bag.png";
import CatWallet from "../assets/img/cat_wallet.png";
import CatShoes from "../assets/img/cat_shoes.png";
import CatEtc from "../assets/img/cat_etc.png";

export default function Home() {
  const dispatch: Function = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  /** [메인팝업] 사용시 아래 popBox 주석 제거 후 사용(+팝업 종료일 = justDate 설정) */
  const [popBox, setPopBox] = useState<boolean>(false);
  const [expireCookie, setExpireCookie] = useState<boolean>(true);
  const [popup, setPopup]: any = useState<any>();

  function getCookiePopbox(name: any) {
    /** getCookie "checkup" 매칭 */
    const matches = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
    if (popup) {
      setPopBox(true);
      if (matches === null) {
        setPopBox(true);
      } else {
        setPopBox(false);
      }
    } else {
      setPopBox(false);
    }
    return matches ? matches[2] : null;
  }
  function setCookie(cname: any, cvalue: any, exdays: any) {
    setPopBox(false);
    const d = new Date();
    d.setHours(exdays.getHours() + 24); // 1일
    const expires = `expires=${d.toUTCString()}`;
    const temp = `${cname}=${cvalue}; ${expires}`;
    document.cookie = temp;
  }
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [isApp, setIsApp] = useState<boolean>(false);
  const forMobile = () => {
    const user = navigator.userAgent;
    if (user.indexOf("iPhone") > -1 || user.indexOf("Android") > -1) {
      setIsMobile(true);
    }
    if (
      user.indexOf("APPMAKE-IOS") > -1 ||
      user.indexOf("APPMAKE-ANDROID") > -1
    ) {
      setIsApp(true);
    }
  };

  const checkCookie = () => {
    if (!expireCookie) {
      setCookie("checkPop", "none", new Date());
    }
  };
  useEffect(() => {
    getCookiePopbox("checkPop");
  }, [popup]);

  /**
   * isSplash
   */
  const [isSplash, setIsSplash] = useState<boolean>(false);
  function setIsSplashHandler(key: string) {
    const { matches } = getCookie(key);
    // console.log(matches, "matches");
    if (!matches) {
      setIsSplash(true);
    }
  }
  useEffect(() => {
    setIsSplashHandler("isSplash");
  }, [document.cookie]);

  const { isLogin } = useSelector(stateLogin);
  useEffect(() => {
    const chkCorrectLogin: Function = async () => {
      try {
        if (isLogin === true) {
          await api.get(`/my/user`).then((response2: any) => {
            const isScript = document.querySelector(`script[class="mapping"]`);
            if (!isScript) {
              const script = document.createElement("script");
              script.setAttribute("class", "mapping");
              script.type = "text/javascript";
              script.text = `function callFromApp() {
                if (typeof app_login_complete === 'function') {
                    app_login_complete('${response2.data.data.user_id}');
                }
            }
            `;
              document.head.appendChild(script);
            } else {
              document.head.removeChild(isScript);
              const script = document.createElement("script");
              script.setAttribute("class", "mapping");
              script.type = "text/javascript";
              script.text = `function callFromApp() {
                if (typeof app_login_complete === 'function') {
                    app_login_complete('${response2.data.data.user_id}');
                }
            }
            `;
              document.head.appendChild(script);
            }
            dispatch(actionsMyInfo.setMyInfo(response2.data));
          });
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(thunkLogin.logout("로그인 정보 오류, 모두 로그아웃"));
          window.location.replace("/");
        }
      }
    };
    chkCorrectLogin();
    forMobile();
  }, []);

  useEffect(() => {
    checkCookie();
  }, [expireCookie]);

  // data
  const [popNew, setPopNew] = useState<any>();
  const [restorationData, setRestorationData] = useState<any>({});
  const [reviewData, setReviewData] = useState<any>([]);
  const [brandstory, setBrandstory] = useState<any>([]);
  const [faq, setFaq] = useState<any>([]);
  const [badge, setBadge]: any = useState([]);
  const [userNo, setUserNo]: any = useState(null);
  const [envData, setEnvData] = useState<any>([]);
  const { data, mutate } = useSWR(`/main/home`);

  useEffect(() => {
    if (data) {
      setPopNew(data.data?.popNew); // 1.메인슬라이더
      setReviewData(data.data?.review); // 3.베스트리뷰
      setBrandstory(data.data?.brandstory); // 4.왜 럭셔리앤올일까요?
      setFaq(data.data?.faq); // 5.FAQ
      setPopup(data.data?.popper);
      setUserNo(data.data?.userNo);
      setBadge(data.data?.count);
      setEnvData(data.data?.envData);
    }
  }, [data]);

  // 메인 슬라이더
  const mainSlickRef = useRef<Slider>(null);
  const [mainSliderIndex, setMainSliderIndex] = useState<number>(1);
  const settings: Settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: true,
    onInit() {
      setMainSliderIndex(1);
    },
    beforeChange(_currentSlide, nextSlide) {
      setMainSliderIndex(nextSlide + 1);
    },
  };
  const mainSlider = {
    slickPrev: () => {
      const slick = mainSlickRef.current;
      if (slick) {
        slick.slickPrev();
      }
    },
    slickNext: () => {
      const slick = mainSlickRef.current;
      if (slick) {
        slick.slickNext();
      }
    },
  };

  const [clientX1, setClientX1] = useState<number>(0);
  const [clientX2, setClientX2] = useState<number>(0);
  const [no, setNo] = useState<number>(0);
  function onLinkClick(link: String) {
    if (clientX1 === clientX2) {
      // console.log(link);
      if (link.startsWith("http")) {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.setAttribute("class", "link-click");
        script.text = `if (typeof app_ExternalLink === "function") {
          app_ExternalLink('${link}')
        } else { window.open('${link}', '_blank') }`;
        document.head.appendChild(script);
      } else {
        navigate(`${link}`);
      }
    }
  }

  // 견적 비교하기 버튼 animation
  const requestBtnAnimationRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (requestBtnAnimationRef.current) {
      Lottie.loadAnimation({
        container: requestBtnAnimationRef.current,
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: require("../assets/animation/animationIcon.json"),
      });
    }
  }, [location]);

  // restoration
  const restorationSliderRef = useRef<Slider>(null);
  const [restorationControllerIndex, setRestorationControllerIndex] =
    useState<number>(0);
  const restoration = {
    slickNext: () => {
      const slick = restorationSliderRef.current;
      if (slick) {
        slick.slickNext();
      }
    },
    slickPrev: () => {
      const slick = restorationSliderRef.current;
      if (slick) {
        slick.slickPrev();
      }
    },
  };
  const restorationSettings: Settings = {
    dots: false,
    autoplay: false,
    arrows: false,
    infinite: false,
    swipeToSlide: true,
    beforeChange(_, nextSlide) {
      setRestorationControllerIndex(nextSlide);
    },
  };

  // Firebase Realtime DataBase
  const FIREBASE_DIR = process.env.REACT_APP_FIREBASE_DIR;
  // console.log(FIREBASE_DIR);
  let realtimeDB: any;
  useEffect(() => {
    if (userNo) {
      realtimeDB = getDatabase(firebaseInstance);
      const restorationRef = ref(
        realtimeDB,
        `${FIREBASE_DIR}/repairing/user_${userNo}/repair`
      );
      onValue(restorationRef, (snapshot) => {
        const data = snapshot.val();
        if (data !== null) {
          const values = Object.values(data).reverse();
          const keys = Object.keys(data).reverse();

          values.forEach((item: any, index: number) => {
            item.rstrNo = keys[index].slice(5);
          });
          setRestorationData(values);
        }
      });
    }
  }, [userNo]);

  // review
  const reviewSliderRef = useRef<Slider>(null);
  const [controllerIndex, setControllerIndex] = useState<number>(0);
  const reviewTagsAreaRef = useRef<HTMLDivElement>(null);
  const [reviewTagsAreaWidth, setReviewTagsAreaWidth] = useState<number>(0);
  const review = {
    slickNext: () => {
      const slick = reviewSliderRef.current;
      if (slick) {
        slick.slickNext();
      }
    },
    slickPrev: () => {
      const slick = reviewSliderRef.current;
      if (slick) {
        slick.slickPrev();
      }
    },
    getTagsAreaWidth: () => {
      const { current } = reviewTagsAreaRef;
      if (current) {
        setReviewTagsAreaWidth(reviewTagsAreaRef.current?.offsetWidth || 0);
      }
    },
  };
  const reviewSliderSettings: Settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 4000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: false,
    swipe: false,
    pauseOnHover: true,
    beforeChange(_, nextSlide) {
      setControllerIndex(nextSlide);
    },
  };
  useEffect(() => {
    review.getTagsAreaWidth();
  });
  let resizeTimer: any = null;
  function resizeComplete() {
    review.getTagsAreaWidth();
  }
  window.addEventListener(
    "resize",
    function () {
      if (resizeTimer) {
        clearTimeout(resizeTimer);
      }
      resizeTimer = setTimeout(resizeComplete, 400);
    },
    false
  );

  // likes-btn
  async function likesHandler(rno: number) {
    await api.patch(`/reviews/${rno}/like`, { id: rno });
  }
  const onLikesClick = async (rno: number, index: number, count: number) => {
    if (!data) return;
    mutate({
      ...data,
      isLiked:
        reviewData[index].flag_likes === "Y"
          ? { result: "N", index, count }
          : { result: "Y", index, count: count + 1 },
    });
    try {
      await likesHandler(rno);
    } catch (error: any) {
      if (error.response.status === 401) {
        alert("로그인이 필요한 서비스입니다.");
      }
    }
  };

  // faq
  const [indexChecked, setIndexChecked] = useState<number | null>(null);
  const checkFaqItemHandler = (ind: number) => {
    if (ind === indexChecked) {
      setIndexChecked(null);
      return;
    }
    setIndexChecked(ind);
  };

  // footer
  const [openInfo, setOpenInfo] = useState<boolean>(false);

  // 채널톡
  // const location = useLocation();
  useEffect(() => {
    const channelTalk: any = document.querySelector(
      `script[class="channelTalk"]`
    );
    if (
      location.pathname === "/" ||
      location.pathname === "/review" ||
      location.pathname === "/request/details"
    ) {
      if (!channelTalk) {
        // console.log(1);
        const script = document.createElement("script");
        script.setAttribute("class", "channelTalk");
        script.type = "text/javascript";
        script.text = ` (function () {
        var w = window;
        if (w.ChannelIO) {
          return (window.console.error || window.console.log || function () {})(
            "ChannelIO script included twice."
          );
        }
        var ch = function () {
          ch.c(arguments);
        };
        ch.q = [];
        ch.c = function (args) {
          ch.q.push(args);
        };
        w.ChannelIO = ch;
        function l() {
          if (w.ChannelIOInitialized) {
            return;
          }
          w.ChannelIOInitialized = true;
          var s = document.createElement("script");
          s.type = "text/javascript";
          s.async = true;
          s.src = "https://cdn.channel.io/plugin/ch-plugin-web.js";
          s.charset = "UTF-8";
          var x = document.getElementsByTagName("script")[0];
          x.parentNode.insertBefore(s, x);
        }
        if (document.readyState === "complete") {
          l();
        } else if (window.attachEvent) {
          window.attachEvent("onload", l);
        } else {
          window.addEventListener("DOMContentLoaded", l, false);
          window.addEventListener("load", l, false);
        }
      })();
      ChannelIO("boot", {
        pluginKey: "5f7cc9cb-ebc5-470c-ad0b-cba8e8a0105b",
      });
    `;
        document.head.appendChild(script);
      } else {
        console.log(2);

        document.head.removeChild(channelTalk);
        const script = document.createElement("script");
        script.setAttribute("class", "channelTalk");
        script.type = "text/javascript";
        script.text = `(function () {
        var w = window;
        if (w.ChannelIO) {
          return (window.console.error || window.console.log || function () {})(
            "ChannelIO script included twice."
          );
        }
        var ch = function () {
          ch.c(arguments);
        };
        ch.q = [];
        ch.c = function (args) {
          ch.q.push(args);
        };
        w.ChannelIO = ch;
        function l() {
          if (w.ChannelIOInitialized) {
            return;
          }
          w.ChannelIOInitialized = true;
          var s = document.createElement("script");
          s.type = "text/javascript";
          s.async = true;
          s.src = "https://cdn.channel.io/plugin/ch-plugin-web.js";
          s.charset = "UTF-8";
          var x = document.getElementsByTagName("script")[0];
          x.parentNode.insertBefore(s, x);
        }
        if (document.readyState === "complete") {
          l();
        } else if (window.attachEvent) {
          window.attachEvent("onload", l);
        } else {
          window.addEventListener("DOMContentLoaded", l, false);
          window.addEventListener("load", l, false);
        }
      })();
      ChannelIO("boot", {
        pluginKey: "5f7cc9cb-ebc5-470c-ad0b-cba8e8a0105b",
      });
    `;
        document.head.appendChild(script);
      }
    } else {
      const deleteScript: any = document.querySelector(
        `script[class="channelTalk"]`
      );
      if (deleteScript !== null) {
        document.head.removeChild(deleteScript);
      }
    }
  }, []);

  const cp = Object.create(null);
  envData.forEach((item: any) => {
    Object.assign(cp, { [item.env_code]: item.env_value });
  });

  return (
    <div className="root">
      <ScrollRestoration
        getKey={(location) => {
          return location.pathname;
        }}
      />
      {location.pathname !== "/" ? (
        <Outlet />
      ) : (
        <>
          <div className="home">
            {/* 헤더 */}
            <div className="home-header">
              <picture
                className="home-header-logo"
                onClick={() => {
                  if (location.pathname === "/" && window.scrollY !== 0) {
                    window.scroll({ top: 0, left: 0, behavior: "smooth" });
                  }
                }}
              >
                <source srcSet={LogoTextWebp} type="image/webp" />
                <img
                  src={LogoText}
                  alt="luxury3.0"
                  width="110px"
                  height="24px"
                />
              </picture>
              <div className="noti">
                <Link to="/notification">
                  <p
                    className="badge"
                    style={
                      badge.noticount > 0 ? { backgroundColor: "#d32f2f" } : {}
                    }
                  />
                  <img
                    // style={isLogin ? { display: "block" } : { display: "none" }}
                    width="24"
                    height="24"
                    src={bell}
                    alt="noti"
                  />
                </Link>
              </div>
            </div>
            {/* 메인 슬라이더 */}
            {/*
            <div className="home-mainSlider">
              <Slider {...settings} ref={mainSlickRef}>
                {popNew?.map((item: any, index: number) => (
                  <div
                    className="slider-contents"
                    key={index}
                    onMouseDown={(
                      e: React.MouseEvent<HTMLDivElement, MouseEvent>
                    ) => {
                      setClientX1(e.clientX);
                    }}
                    onMouseUp={(
                      e: React.MouseEvent<HTMLDivElement, MouseEvent>
                    ) => {
                      setClientX2(e.clientX);
                      setNo(item.banner_no);
                    }}
                    onClick={() => onLinkClick(item.banner_link)}
                  >
                    <div className="slider-category">{item.banner_tag}</div>
                    <img
                      className="slider-image"
                      src={item?.banner_image}
                      alt="main-slider-image"
                      loading={index ? "lazy" : "eager"}
                    />
                  </div>
                ))}
              </Slider>
              <button
                type="button"
                className="slider-arrow-btn left"
                onClick={() => mainSlider.slickPrev()}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.5607 5.25L5.56066 11.25L21 11.25V12.75L5.56066 12.75L11.5607 18.75L10.5 19.8107L3.21967 12.5303C2.92678 12.2374 2.92678 11.7626 3.21967 11.4697L10.5 4.18934L11.5607 5.25Z"
                  />
                </svg>
              </button>
              <button
                type="button"
                className="slider-arrow-btn right"
                onClick={() => mainSlider.slickNext()}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.125 10L16.875 10M16.875 10L11.25 4.375M16.875 10L11.25 15.625"
                    // stroke=""
                    strokeWidth="1.5"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              <div className="index">
                {mainSliderIndex} / {popNew?.length}
              </div>
            </div>
                  */}
            {/* 견적 비교하기 버튼 */}
            <div className="button-wrapper" style={{ marginTop: "20px" }}>
              <button
                type="button"
                className="moveToRequest-btn"
                onClick={() => navigate(`request`)}
              >
                <div className="item">
                  <div className="btn-img-1" ref={requestBtnAnimationRef} />
                  <div className="btn-text">
                    <div className="tag-270">270여개</div>
                    <p className="text-1">수선/클리닝 마스터들 견적 비교하기</p>
                    <p className="text-2">
                      가격부터 검증된 실력, 기간까지 비교하세요
                    </p>
                  </div>
                </div>
                <div className="btn-img-2" />
              </button>
            </div>

            {/* 견적 의뢰하기 카테고리 버튼 */}
            {/*
            <div className="request-retoration" id="requestRetoration">
              <div className="title">
                <div className="name">명품수선 무료 견적 받기</div>
                <div className="contents button-wrapper-cat">
                  <button
                    type="button"
                    className="cat-btn"
                    onClick={() => navigate(`request`)}
                  >
                    <img className="item" src={CatBag} alt="가방" />
                    <div className="item-title">가방</div>
                  </button>
                  <button
                    type="button"
                    className="cat-btn"
                    onClick={() => navigate(`request`)}
                  >
                    <img className="item" src={CatWallet} alt="지갑" />
                    <div className="item-title">지갑</div>
                  </button>
                  <button
                    type="button"
                    className="cat-btn"
                    onClick={() => navigate(`request`)}
                  >
                    <img className="item" src={CatShoes} alt="신발" />
                    <div className="item-title">신발</div>
                  </button>
                  <button
                    type="button"
                    className="cat-btn"
                    onClick={() => navigate(`request`)}
                  >
                    <img className="item" src={CatEtc} alt="기타" />
                    <div className="item-title">기타</div>
                  </button>
                </div>
              </div>
            </div>
            */}
            {/* 진행중인 수선 */}
            {Object.keys(restorationData).length > 0 && (
              <div className="restoration" id="restoration">
                <div className="title">
                  <div className="name">
                    진행중인 의뢰
                    <span className="length">
                      {Object.keys(restorationData).length}건
                    </span>
                  </div>
                  <div className="link-btn" id="link-btn">
                    <Link
                      to="/timeline?tab=0"
                      state={{ redirect: location.pathname }}
                    >
                      전체내역
                    </Link>
                    <img src={rightArrow} alt="rightArrow" />
                  </div>
                </div>
                <div className="contents">
                  <Slider {...restorationSettings} ref={restorationSliderRef}>
                    {restorationData.length !== 0 &&
                      restorationData.map((item: any) => (
                        <div key={item.rstrNo}>
                          <TimelineBox item={item} current home />
                        </div>
                      ))}
                  </Slider>
                  {restorationData.length > 1 && (
                    <div className="slider-controller-area">
                      <button
                        type="button"
                        onClick={() => restoration.slickPrev()}
                        aria-label="left button"
                      >
                        <div className="left" />
                      </button>
                      <div className="controller-index">
                        <div className="g-900">
                          {restorationControllerIndex + 1}
                        </div>
                        <div className="g-300">/</div>
                        <div className="g-500">{restorationData.length}</div>
                      </div>
                      <button
                        type="button"
                        onClick={() => restoration.slickNext()}
                        aria-label="left button"
                      >
                        <div className="right" />
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}
            {/* 베스트 리뷰 */}
            <div className="review" id="review">
              <div className="title">
                <div>베스트 리뷰</div>
                <div
                  className="link-btn"
                  id="link-btn"
                  onClick={() => {
                    dispatch(
                      reviewActions.setRedirectPath({
                        redirect: `${location.pathname}`,
                      })
                    );
                    navigate(`/review`);
                  }}
                >
                  <span>전체리뷰</span>
                  <img
                    src={rightArrow}
                    alt="rightArrow"
                    width="16px"
                    height="16px"
                  />
                </div>
              </div>
              <div className="review-slider">
                <Slider {...reviewSliderSettings} ref={reviewSliderRef}>
                  {reviewData.length !== 0 &&
                    reviewData.map((item: any, index: number) => (
                      <div key={index}>
                        <div>
                          <div className="line-0">
                            <div className="line-1">
                              <span>{item.user_name}</span>
                              <span className="bar">|</span>
                              <span className="line-2">
                                <span className="star-img" />
                                <span className="star-points">
                                  {(item.points * 0.1).toFixed(1)}
                                </span>
                              </span>
                              <span className="bar">|</span>
                              <span className="line-2">
                                <span className="name">비용</span>
                                <span className="price">
                                  {comma(item.amount)}
                                </span>
                              </span>
                            </div>
                            {item.flag_me === "N" && (
                              <Link
                                to={`/review/${item.review_no}/report`}
                                className="report-btn"
                              >
                                신고
                              </Link>
                            )}
                          </div>
                          <div className="before-after-slider-area">
                            <div className="review-desktop">
                              <div className="desktop-img">
                                <img
                                  src={item.before[0].image_url}
                                  alt="best-review-before-image"
                                  loading={index ? "lazy" : "eager"}
                                />
                                <div className="caption before">작업전</div>
                              </div>
                              <div className="desktop-img">
                                <img
                                  src={item.after[0].image_url}
                                  alt="best-review-after-image"
                                  loading={index ? "lazy" : "eager"}
                                />
                                <div className="caption after">작업후</div>
                              </div>
                            </div>
                            <ReactCompareSlider
                              onlyHandleDraggable
                              className="review-mobile"
                              handle={
                                <div
                                  style={{
                                    display: "grid",
                                    placeContent: "center",
                                    height: "100%",
                                    width: "2px",
                                    background: "#fff",
                                  }}
                                >
                                  <div className="handle-img" />
                                </div>
                              }
                              itemOne={
                                <div className="comparison-img">
                                  <img
                                    src={item.before[0].image_url}
                                    alt="best-review-before-img"
                                    loading={index ? "lazy" : "eager"}
                                  />
                                  <div className="comparison-imgcaption before">
                                    작업전
                                  </div>
                                </div>
                              }
                              itemTwo={
                                <div className="comparison-img">
                                  <img
                                    src={item.after[0].image_url}
                                    alt="best-review-before-img"
                                    loading={index ? "lazy" : "eager"}
                                  />
                                  <div className="comparison-imgcaption after">
                                    작업후
                                  </div>
                                </div>
                              }
                            />
                          </div>
                          <div className="tags-area" ref={reviewTagsAreaRef}>
                            {item?.tags
                              ?.filter(
                                (_: any, i: number) =>
                                  (i + 1) * 80 < reviewTagsAreaWidth - 28
                              )
                              ?.map((tag: string, ind: number) => (
                                <div className="tag" key={ind}>
                                  # {tag}
                                </div>
                              ))}
                            {item?.tags?.filter(
                              (_: any, i: number) =>
                                (i + 1) * 80 >= reviewTagsAreaWidth - 28
                            )?.length !== 0 && (
                              <div className="tag">
                                +
                                {
                                  item?.tags?.filter(
                                    (_: any, i: number) =>
                                      (i + 1) * 80 >= reviewTagsAreaWidth - 28
                                  )?.length
                                }
                              </div>
                            )}
                          </div>
                          <div className="message-area">
                            <div className="message">{item?.message}</div>
                            <Link
                              to={`/review/${item?.review_no}`}
                              className="view-more-btn"
                            >
                              더보기
                            </Link>
                          </div>
                          <button
                            type="button"
                            className={`likes-btn ${
                              data.isLiked?.result === "Y" &&
                              data.isLiked?.index === index
                                ? "active"
                                : item.flag_likes === "Y"
                                ? "active"
                                : ""
                            }`}
                            onClick={() =>
                              onLikesClick(item.review_no, index, item.likes)
                            }
                          >
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M4.99963 6.5H1.99963C1.86703 6.5 1.73985 6.55268 1.64608 6.64645C1.55231 6.74022 1.49963 6.86739 1.49963 7V12.5C1.49963 12.6326 1.55231 12.7598 1.64608 12.8536C1.73985 12.9473 1.86703 13 1.99963 13H4.99963M4.99963 6.5V13M4.99963 6.5L7.49963 1.5C7.76228 1.5 8.02235 1.55173 8.265 1.65224C8.50765 1.75275 8.72813 1.90007 8.91385 2.08579C9.09956 2.2715 9.24688 2.49198 9.34739 2.73463C9.4479 2.97728 9.49963 3.23736 9.49963 3.5V5H13.3669C13.5086 5 13.6488 5.03015 13.7781 5.08846C13.9073 5.14677 14.0227 5.2319 14.1165 5.3382C14.2104 5.4445 14.2805 5.56954 14.3224 5.70502C14.3642 5.84051 14.3767 5.98334 14.3591 6.12404L13.6091 12.124C13.5789 12.3659 13.4614 12.5884 13.2787 12.7497C13.0959 12.911 12.8606 13 12.6169 13H4.99963"
                                stroke=""
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            <span>도움이 돼요!</span>
                            <span className="grey-800">
                              {data.isLiked?.result === "Y" &&
                              data.isLiked?.index === index
                                ? data.isLiked.count
                                : data.isLiked
                                ? data.isLiked.count
                                : item.likes}
                              명
                            </span>
                          </button>
                        </div>
                      </div>
                    ))}
                </Slider>
                <div className="slider-controller-area">
                  <button
                    type="button"
                    onClick={() => review.slickPrev()}
                    aria-label="left button"
                  >
                    <div className="left" />
                  </button>
                  <div className="controller-index">
                    <div className="g-900">{controllerIndex + 1}</div>
                    <div className="g-300">/</div>
                    <div className="g-500">{reviewData.length}</div>
                  </div>
                  <button
                    type="button"
                    onClick={() => review.slickNext()}
                    aria-label="right button"
                  >
                    <div className="right" />
                  </button>
                </div>
              </div>
            </div>
            {/* 왜 럭셔리앤올일까요? */}
            {/*
            <div className="our-services">
              <div className="title">
                <div>왜 럭셔리앤올일까요?</div>
                <div
                  className="link-btn"
                  id="link-btn"
                  onClick={() => {
                    dispatch(
                      reviewActions.setRedirectPath({
                        redirect: `${location.pathname}`,
                      })
                    );
                    navigate(`/brandstory`, {
                      state: location.pathname,
                    });
                  }}
                >
                  <span>전체보기</span>
                  <img
                    src={rightArrow}
                    alt="rightArrow"
                    width="16px"
                    height="16px"
                  />
                </div>
              </div>
              <div>
                <div className="contents-area">
                  <ScrollContainer className="scroll-container">
                    {brandstory.map((item: any, index: number) => (
                      <img
                        key={index}
                        className="content-item"
                        src={item.image_thumb}
                        alt="brand-story-image"
                        onClick={() => navigate(`/brandstory/${item.board_no}`)}
                        loading="lazy"
                      />
                    ))}
                  </ScrollContainer>
                </div>
              </div>
            </div>
            */}
            {/* 내 명품, 수선이 될까요? */}
            <picture className="service-guide" id="repair-guide-home">
              <source
                srcSet={SubBannerWebp}
                type="image/webp"
                className="service-guide-img"
                onClick={() => navigate("/repair-guide")}
              />
              <img
                src={SubBannerSvg}
                alt="sub-banner"
                className="service-guide-img"
                onClick={() => navigate("/repair-guide")}
                loading="lazy"
              />
            </picture>
            {/* 자주 묻는 질문 */}
            {/*
            <div className="home-faq" id="home-faq">
              <div className="title">
                <div>자주 묻는 질문</div>
                <div
                  className="link-btn"
                  id="link-btn"
                  onClick={() => {
                    dispatch(
                      reviewActions.setRedirectPath({
                        redirect: `${location.pathname}`,
                      })
                    );
                    navigate(`/service`);
                  }}
                >
                  <span>전체보기</span>
                  <img
                    src={rightArrow}
                    alt="rightArrow"
                    width="16px"
                    height="16px"
                  />
                </div>
              </div>
              <div className="faq-contents">
                {faq.map((item: any, index: number) => (
                  <div className="faq-item" key={index}>
                    <div
                      className="faq-ques"
                      onClick={() => checkFaqItemHandler(index)}
                    >
                      <div className="col">
                        <div className="ques-img" />
                        <div>{item.subject}</div>
                      </div>
                      <div
                        className={`arrow-img ${
                          indexChecked === index ? "active" : ""
                        }`}
                      />
                    </div>
                    <div
                      className={`faq-answ ${
                        indexChecked === index ? "active" : ""
                      }`}
                    >
                      <p className="faq-answ-contents">{item.content}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
                    */}
            {/* 사업자 정보 */}
            <div className="home-footer" id="home-footer">
              <div
                className="footer-title"
                onClick={() => setOpenInfo((prev) => !prev)}
              >
                {cp.ENV_COMPANY_NAME} 사업자 정보
                <div className={`arrow-btn ${openInfo ? "active" : ""}`} />
              </div>
              <div className={`footer-contents ${openInfo ? "active" : ""}`}>
                <div className="line">
                  <span>대표이사</span>
                  <span>{cp.ENV_COMPANY_CEO}</span>
                </div>
                <div className="line">
                  <span>사업자번호</span>
                  <span>{cp.ENV_COMPANY_SN}</span>
                </div>
                <div className="line">
                  <span>통신판매업신고</span>
                  <span>{cp.ENV_COMM_SN}</span>
                </div>
                <div className="line">
                  <span>주소</span>
                  <span>{cp.ENV_WAREHOUSE_ADDR}</span>
                </div>
                <div className="line">
                  <span>고객센터</span>
                  <span>{cp.ENV_COMPANY_EMAIL}</span>
                </div>
                {/*
                <div className="line">
                  <span>고객센터</span>
                  <span>
                    {isMobile ? (
                      <a href={`tel:${cp.ENV_COMPANY_TEL}`}>
                        {cp.ENV_COMPANY_TEL}
                      </a>
                    ) : (
                      <span>{cp.ENV_COMPANY_TEL}</span>
                    )}
                  </span>
                </div>
                    */}
                <div className="line">
                  <span>개인정보관리책임자</span>
                  <span>{cp.ENV_COMPANY_PSN}</span>
                </div>
                <div className="company-name">ⓒ{cp.ENV_COMPANY_ENG}</div>
              </div>
              <div className={`link ${openInfo ? "" : "close"}`}>
                <Link to="/terms">이용약관</Link>
                <span className="bar">|</span>
                <Link to="/policy" className="bold">
                  개인정보 처리방침
                </Link>
                <span className="bar">|</span>
                <Link to="/store-info">오프라인 매장찾기</Link>
                <span className="bar">|</span>
                <Link to="/contact">제휴문의</Link>
              </div>
              <div className="sns">
                <a
                  className="icon"
                  href="https://www.youtube.com/channel/UCgfkMYhc7dSIPr2GBPv9r4g"
                  target="blank"
                >
                  <img src={IcYoutube} alt="IcYoutube" />
                </a>
                <a
                  className="icon"
                  href="https://www.instagram.com/luxurynall_official"
                  target="blank"
                >
                  <img src={IcInstagram} alt="IcInstagram" />
                </a>
              </div>
            </div>
          </div>
          {/* 팝업2 */}
          {popBox && (
            <PopupSlide
              // isMobile={isMobile}
              setPopBox={setPopBox}
              setExpireCookie={setExpireCookie}
              imgData={popup}
            />
          )}
          {/* 팝업1 */}
          {isApp && isSplash && <Splash2 />}
          {/* 네비바 */}
          <Navbar current="home" />
        </>
      )}
      {/* ChannelIO 라이브러리 */}
      {(location.pathname === "/" ||
        location.pathname === "/review" ||
        location.pathname === "/brandstory" ||
        location.pathname === "/magazine" ||
        location.pathname === "/request/details") && (
        <ReactChannelIO
          pluginKey="5f7cc9cb-ebc5-470c-ad0b-cba8e8a0105b"
          language="ko"
        >
          <ChannelBot />
        </ReactChannelIO>
      )}
    </div>
  );
}
